import { Select } from 'antd';
import type { ProdutoUnidade } from '../types/ProdutoUnidade';
import { useProdutoUnidadeGetQuery } from '../api/apiProdutoUnidadeGet';

export function ProdutoUnidadeSelect({
    disabled,

    value,
    onChange,
}: {
    disabled?: boolean;
    /** pru_idpk ou pru_sigla */
    value?: number | string | null;
    onChange?: (pru_idpk: number | null, unidade: ProdutoUnidade | null) => void;
}) {
    const { data, isFetching } = useProdutoUnidadeGetQuery();

    const unidades = data?.registros || [];

    const options = unidades.map((item) => ({
        label: item.pru_descricao,
        value: item.pru_idpk,
    }));

    const innerValue =
        typeof value === 'string'
            ? unidades.find((item) => item.pru_sigla === value)?.pru_idpk
            : value;

    const handleChange = (pru_idpk: number | undefined): void => {
        if (!onChange) {
            return;
        }

        const unidade = unidades.find((item) => item.pru_idpk === pru_idpk);
        onChange(pru_idpk || null, unidade || null);
    };

    return (
        <Select
            allowClear={true}
            className='w-full'
            disabled={disabled}
            loading={isFetching}
            onChange={handleChange}
            options={options}
            showSearch={{
                optionFilterProp: 'label',
            }}
            value={innerValue}
        />
    );
}
